/*
 * @Author: liujunhong
 * @Date: 2022-12-08
 * @Desc:
 */

import { init } from '@rematch/core'
import models from './loader'

const store = init({ models });


export default store;